"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormGroup = require("react-bootstrap/lib/FormGroup");

var _FormGroup2 = _interopRequireDefault(_FormGroup);

var _InputGroup = require("react-bootstrap/lib/InputGroup");

var _InputGroup2 = _interopRequireDefault(_InputGroup);

var _InputGroupAddon = require("react-bootstrap/lib/InputGroupAddon");

var _InputGroupAddon2 = _interopRequireDefault(_InputGroupAddon);

var _InputGroupButton = require("react-bootstrap/lib/InputGroupButton");

var _InputGroupButton2 = _interopRequireDefault(_InputGroupButton);

var _DropdownButton = require("react-bootstrap/lib/DropdownButton");

var _DropdownButton2 = _interopRequireDefault(_DropdownButton);

var _Button = require("./../../Button");

var _Button2 = _interopRequireDefault(_Button);

var _HelpBlockContainer = require("../HelpBlockContainer");

var _HelpBlockContainer2 = _interopRequireDefault(_HelpBlockContainer);

var _InputAddon = require("./../InputAddon");

var _InputAddon2 = _interopRequireDefault(_InputAddon);

var _Label = require("./../Label");

var _Label2 = _interopRequireDefault(_Label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputWrapper = function (_React$Component) {
  _inherits(InputWrapper, _React$Component);

  function InputWrapper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InputWrapper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InputWrapper.__proto__ || Object.getPrototypeOf(InputWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.flattenAddons = function (children) {
      var addonsArray = [];
      children.forEach(function (child) {
        if (Array.isArray(child)) {
          addonsArray.push.apply(addonsArray, _toConsumableArray(_this.flattenAddons(child)));
        } else {
          if (!child) return;
          var wrappedChild = child.type === _InputAddon2.default ? child : _this.wrapAddon(child);
          addonsArray.push(wrappedChild);
        }
      });
      return addonsArray;
    }, _this.setAddons = function () {
      var children = _this.props.children;

      if (!children) {
        return;
      } else if (!Array.isArray(children)) {
        return _this.wrapAddon(children);
      } else {
        return _this.flattenAddons(children);
      }
    }, _this.wrapAddon = function (addon) {
      var _this$props = _this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          htmlId = _this$props.htmlId,
          validationState = _this$props.validationState;
      var type = addon.type;

      // If child is already wrapped we just pass it along unaltered

      var acceptedTypes = [_InputGroupAddon2.default, _InputGroupButton2.default];
      if (!type || acceptedTypes.includes(type)) {
        return addon;
      } else if (type === _InputAddon2.default) {
        return _react2.default.cloneElement(addon, {
          disabled: disabled,
          validationState: validationState
        });
      } else if (type === _Button2.default || type === _DropdownButton2.default) {
        // If child is an unwrapped Button or DropdownButton we wrap
        var bsStyle = validationState === "warning" ? "warning" : validationState === "error" ? "danger" : "default";
        return _react2.default.createElement(
          _InputGroupButton2.default,
          { className: "addon-wrapper" },
          _react2.default.cloneElement(addon, {
            bsStyle: bsStyle,
            componentClass: undefined,
            disabled: disabled
          })
        );
      }

      return _react2.default.createElement(
        _InputAddon2.default,
        {
          className: className + "-addon",
          disabled: disabled,
          key: htmlId + "-" + addon.props.htmlId,
          addonType: "addon",
          validationState: validationState
        },
        addon
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InputWrapper, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          addOnPosition = _props.addOnPosition,
          className = _props.className,
          disabled = _props.disabled,
          displayLabel = _props.displayLabel,
          formControl = _props.formControl,
          helpBlockMessage = _props.helpBlockMessage,
          htmlId = _props.htmlId,
          inputPrefix = _props.inputPrefix,
          inputSuffix = _props.inputSuffix,
          label = _props.label,
          layout = _props.layout,
          required = _props.required,
          validationState = _props.validationState;

      var addons = this.setAddons();
      var containerClass = layout === "horizontal" ? " input-side-by-side" : "";
      var prefixSuffixClasses = "" + (inputPrefix ? "input-group--prefix " : "") + (inputSuffix ? "input-group--suffix" : "");
      var wrapComponentWithFormGroup = addons || inputPrefix || inputSuffix;
      return _react2.default.createElement(
        _FormGroup2.default,
        {
          id: htmlId + "-inputWrapper",
          controlId: htmlId,
          className: "input-wrapper " + (className || "") + " " + htmlId + "__formGroup" + containerClass,
          validationState: validationState
        },
        displayLabel && _react2.default.createElement(
          _Label2.default,
          {
            className: className,
            htmlId: htmlId + "-label",
            required: required
          },
          label
        ),
        wrapComponentWithFormGroup ? _react2.default.createElement(
          _InputGroup2.default,
          { className: prefixSuffixClasses },
          addOnPosition === "prepend" && addons,
          inputPrefix && _react2.default.createElement(
            _InputAddon2.default,
            {
              className: "addon-prefix",
              disabled: disabled,
              addonType: "addon"
            },
            inputPrefix
          ),
          formControl,
          inputSuffix && _react2.default.createElement(
            _InputAddon2.default,
            {
              className: "addon-suffix",
              disabled: disabled,
              addonType: "addon"
            },
            inputSuffix
          ),
          addOnPosition === "append" && addons
        ) : formControl,
        _react2.default.createElement(_HelpBlockContainer2.default, {
          status: validationState,
          message: helpBlockMessage
        })
      );
    }
  }]);

  return InputWrapper;
}(_react2.default.Component);

InputWrapper.propTypes = {
  addOnPosition: _propTypes2.default.oneOf(["append", "prepend"]).isRequired,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool.isRequired,
  displayLabel: _propTypes2.default.bool.isRequired,
  formControl: _propTypes2.default.node.isRequired,
  helpBlockMessage: _propTypes2.default.string,
  htmlId: _propTypes2.default.string.isRequired,
  inputPrefix: _propTypes2.default.string,
  inputSuffix: _propTypes2.default.string,
  label: _propTypes2.default.string,
  layout: _propTypes2.default.oneOf(["vertical", "horizontal"]).isRequired,
  required: _propTypes2.default.bool.isRequired,
  validationState: _propTypes2.default.string
};

InputWrapper.defaultProps = {
  addOnPosition: "append",
  disabled: false,
  displayLabel: true,
  layout: "vertical",
  required: false
};

InputWrapper.Addon = _InputAddon2.default;

exports.default = InputWrapper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cx/ui/internal/InputWrapper/InputWrapper.js
// module id = 536
// module chunks = 0